/**
 * Landing config process handlers
 * Public read for quotes section visibility on homepage
 */

import { handleRequest } from './config'
import { ApiResponse } from '../types'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../libs/Firebase'

export type GetLandingQuotesSectionEnabledRequest = Record<string, never>

export type GetLandingQuotesSectionEnabledResponse = {
  success: boolean
  enabled: boolean
  error?: string
}

/**
 * Get whether the quotes section is enabled on the landing page.
 * Defaults to true when doc does not exist.
 */
export const getLandingQuotesSectionEnabled = async (): Promise<ApiResponse<boolean>> => {
  return handleRequest(
    () => Promise.resolve({ data: true, success: true } as ApiResponse<boolean>),
    async () => {
      try {
        const callable = httpsCallable<GetLandingQuotesSectionEnabledRequest, GetLandingQuotesSectionEnabledResponse>(
          functions,
          'getLandingQuotesSectionEnabled'
        )
        const result = await callable({})

        if (!result.data.success) {
          const errorMessage = result.data.error || 'Failed to fetch landing quotes section config'
          throw new Error(errorMessage)
        }

        return {
          data: result.data.enabled,
          success: true
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          throw error
        }
        throw new Error('Unknown error while fetching landing quotes section config')
      }
    }
  )
}
